// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (pointer:coarse){@supports (-webkit-backdrop-filter:blur(1px)) and (overscroll-behavior-y:none){html{min-height:100.3%;overscroll-behavior-y:none}}}@media screen and (pointer:coarse){@supports (-webkit-backdrop-filter:blur(1px)) and (not (overscroll-behavior-y:none)){html{height:100%;overflow:hidden}body{margin:0;max-height:100%;overflow:auto;-webkit-overflow-scrolling:touch}}}body{overscroll-behavior-y:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
